import { useTranslations } from '@vocab/react';
import { Box, Text } from 'braid-design-system';

import { TextLink } from 'src/components';
import { TRACKING_CODES } from 'src/shared/constant';
import { useConfig } from 'src/shared/hooks';
import { getAgeLimit } from 'src/utils/getAgeLimit';

import translations from './.vocab';

export const TermsPrivacy = ({}) => {
  const { t: formT } = useTranslations(translations);
  const { brand, country, isAnz } = useConfig();
  const isANZHK = country === 'hk' || isAnz;

  return (
    <Box>
      <Text>
        {formT(
          'By providing your personal information, you agree to the Collection Notice and Privacy policy.',
          {
            collection(children) {
              return (
                <TextLink
                  href="/collection-notice"
                  tracking={TRACKING_CODES.content_element_pressed}
                >
                  {children}
                </TextLink>
              );
            },
            privacy(children) {
              return (
                <TextLink
                  href="/privacy"
                  tracking={TRACKING_CODES.content_element_pressed}
                >
                  {children}
                </TextLink>
              );
            },
          },
        )}{' '}
        {/* Do not show age requirement when on ANZHK */}
        {!isANZHK &&
          formT(
            'If you are under {age} years old, you must have parental consent for {brand} and affiliates to process your personal data.',
            {
              age: getAgeLimit(country).toString(),
              brand,
            },
          )}
      </Text>
    </Box>
  );
};
